import React from 'react';
import { Container } from '@mui/material';

function SuccessVoucher() {

    return (
        <Container maxWidth="sm" style={{textAlign: 'center'}}>
            <h1>Your purchase completed!</h1>
            <p>We will send the voucher shortly</p>
        </Container>
    );
}

export default SuccessVoucher;